var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.847 19.015a9.365 9.365 0 1 1 9.365-9.365 9.373 9.373 0 0 1-9.365 9.365zm0-17.877a8.52 8.52 0 1 0 0 17.04 8.52 8.52 0 0 0 0-17.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.724 19.015a9.365 9.365 0 1 1 9.357-9.365 9.373 9.373 0 0 1-9.357 9.365zm0-17.877a8.52 8.52 0 1 0-.017 17.04 8.52 8.52 0 0 0 .017-17.04zM9.847 36.883a9.356 9.356 0 1 1 9.365-9.356 9.365 9.365 0 0 1-9.365 9.356zm0-17.868a8.512 8.512 0 1 0 8.52 8.512 8.52 8.52 0 0 0-8.52-8.512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.724 36.883a9.356 9.356 0 1 1 9.357-9.356 9.365 9.365 0 0 1-9.357 9.356zm0-17.868a8.512 8.512 0 1 0 8.512 8.512 8.52 8.52 0 0 0-8.512-8.512z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid);
export default __webpack_public_path__ + "static/media/solid.9ed1932a30c278e21cfe2af5356891a1.svg";
export { ForwardRef as ReactComponent };